import React, { useState } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

import { Experiment } from '../../../lib/PlannerDTOs';
import { ExperimentFormInfoProvider } from '../../ExperimentFormV2/contexts/ExperimentFormInfoProvider';
import {
  FormBody,
  FormSectionWrapper,
} from '../../ExperimentFormV2/ExperimentFormV2';
import { JsonCard } from '../../ExperimentFormV2/Sections/JsonPreview';
import ExperimentDetail from './ExperimentDetail';

function ExperimentDetailToggleView({
  experiment,
}: {
  experiment: Experiment;
}) {
  const VISUAL_SETUP = 'VISUAL_SETUP';
  const JSON = 'JSON';

  const [viewType, setViewType] = useState<string>(VISUAL_SETUP);
  return (
    <>
      <div
        style={{
          position: 'sticky',
          top: '46px',
          zIndex: 2,
          padding: '16px 24px',
          background: '#f7f7f7',
        }}
      >
        <CustomToggleBox>
          <div
            className="toggle-box"
            onClick={() => setViewType(VISUAL_SETUP)}
            style={{
              width: '50%',
              background: `${viewType === VISUAL_SETUP ? '#FFF' : ''}`,
              borderRadius: 8,
              textAlign: 'center',
              padding: '8px 0',
            }}
          >
            <Typography.Text strong>Visual Setup</Typography.Text>
          </div>
          <div
            className="toggle-box"
            onClick={() => setViewType(JSON)}
            style={{
              width: '50%',
              background: `${viewType === JSON ? '#FFF' : ''}`,
              textAlign: 'center',
              borderRadius: 8,
              padding: '8px 0',
            }}
          >
            <Typography.Text strong>JSON</Typography.Text>
          </div>
        </CustomToggleBox>
      </div>
      <FormBody style={{ paddingTop: '4px' }}>
        <ExperimentFormInfoProvider>
          <FormSectionWrapper>
            {viewType === VISUAL_SETUP && (
              <ExperimentDetail experiment={experiment} />
            )}
            {viewType === JSON && (
              <JsonCard
                title={null}
                subtitle={null}
                payload={experiment}
                defaultOpen={true}
                style={{ border: '1px solid #E8E8E8' }}
              />
            )}
          </FormSectionWrapper>
        </ExperimentFormInfoProvider>
      </FormBody>
    </>
  );
}

export const CustomToggleBox = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  display: flex;
  gap: 4px;
  padding: 2px;
  background: #e8e8e8;
`;

export default ExperimentDetailToggleView;
